module.exports = __webpack_public_path__ + "img/newImg.0327bb70.png";